import React from "react";
import { Link } from "@bloomberg/media-ui-article";

import styles from "./styles.module.css";

export default function ContactUs() {
    const contactUrl =
        "https://www.bloomberg.com/help/question/submit-feedback-news-coverage/";
    return (
        <div className={styles.contactUsContainer}>
            <Link href={contactUrl} target="_blank">
                <span className={styles.contactUsCopy}>Contact us:</span>
                <div className={styles.contactUsLink}>
                    Provide news feedback or report an error
                </div>
            </Link>
        </div>
    );
}
